// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-summary-container {
  display: flex;
  justify-content: space-between;
  margin: 2px;
  background-color: white;
}

.left-column, .right-column {
  flex: 1 1;
  margin: 4px;
  transition: all 0.3s ease; 
}

.left-column.full-width {
  flex-basis: 60%; 
}
.right-column.full-width{
  flex-basis: 60%;
}

.left-column.half-width {
  flex-basis: 70%; 
}
.right-column.half-width{
  flex-basis: 28%;
}

/* table {
  width: 100%;
  border-collapse: collapse;
 
}

table, th, td {
  border: 1px solid black;
 
  padding: 6px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
  padding: 5px;
}
.systemCost th{
  width:50%;
}

input {
  width: 90%;
  padding: 2px;
  box-sizing: border-box;
}

td input {
  margin: 1px 0;
} */
/* General table styles */
table {
width: 100%;
border-collapse: collapse;
font-family: Arial, sans-serif;
font-size: 14px;
color: #333;
}


table, th, td {
border: 1px solid black;
padding: 6px;
text-align: left;

}


th {
background-color: #f2f2f2;
padding: 8px;
font-weight: bold;
color: #555;
text-transform: uppercase;
}


tr:nth-child(even) {
background-color: #f9f9f9;
}
tr:nth-child(odd) {
background-color: #ffffff;
}


.systemCost th {
width: 50%;
}


/* tr:hover {
background-color: #c0c5c6;
} */


input {
width: 90%;
padding: 4px;
box-sizing: border-box;
border: 1px solid #ccc;
border-radius: 4px;
}
input:hover {
border-color: blue; 
box-shadow: 0 0 5px rgba(0, 0, 0, 0.2); 
}

td input {
margin: 2px 0;
}


th, td {
border-radius: 4px;
}


.excel-file{
  margin-bottom:20px;
}



@keyframes blink {
  50% {
      opacity: 0;
  }
}

.blink {
  animation: blink 1s step-start infinite;
}


@media (max-width: 768px) {
  .project-summary-container {
    flex-direction: column;
  }

  .left-column.full-width, .right-column.full-width,
  .left-column.half-width, .right-column.half-width {
    flex-basis: 100%; 
  }

  .left-column, .right-column {
    margin-bottom: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NEW FM/Page1/ProjectSummary.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;AACH,yBAAyB;AACzB;AACA,WAAW;AACX,yBAAyB;AACzB,8BAA8B;AAC9B,eAAe;AACf,WAAW;AACX;;;AAGA;AACA,uBAAuB;AACvB,YAAY;AACZ,gBAAgB;;AAEhB;;;AAGA;AACA,yBAAyB;AACzB,YAAY;AACZ,iBAAiB;AACjB,WAAW;AACX,yBAAyB;AACzB;;;AAGA;AACA,yBAAyB;AACzB;AACA;AACA,yBAAyB;AACzB;;;AAGA;AACA,UAAU;AACV;;;AAGA;;GAEG;;;AAGH;AACA,UAAU;AACV,YAAY;AACZ,sBAAsB;AACtB,sBAAsB;AACtB,kBAAkB;AAClB;AACA;AACA,kBAAkB;AAClB,sCAAsC;AACtC;;AAEA;AACA,aAAa;AACb;;;AAGA;AACA,kBAAkB;AAClB;;;AAGA;EACE,kBAAkB;AACpB;;;;AAIA;EACE;MACI,UAAU;EACd;AACF;;AAEA;EACE,uCAAuC;AACzC;;;AAGA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".project-summary-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin: 2px;\r\n  background-color: white;\r\n}\r\n\r\n.left-column, .right-column {\r\n  flex: 1;\r\n  margin: 4px;\r\n  transition: all 0.3s ease; \r\n}\r\n\r\n.left-column.full-width {\r\n  flex-basis: 60%; \r\n}\r\n.right-column.full-width{\r\n  flex-basis: 60%;\r\n}\r\n\r\n.left-column.half-width {\r\n  flex-basis: 70%; \r\n}\r\n.right-column.half-width{\r\n  flex-basis: 28%;\r\n}\r\n\r\n/* table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n \r\n}\r\n\r\ntable, th, td {\r\n  border: 1px solid black;\r\n \r\n  padding: 6px;\r\n  text-align: left;\r\n}\r\n\r\nth {\r\n  background-color: #f2f2f2;\r\n  padding: 5px;\r\n}\r\n.systemCost th{\r\n  width:50%;\r\n}\r\n\r\ninput {\r\n  width: 90%;\r\n  padding: 2px;\r\n  box-sizing: border-box;\r\n}\r\n\r\ntd input {\r\n  margin: 1px 0;\r\n} */\r\n/* General table styles */\r\ntable {\r\nwidth: 100%;\r\nborder-collapse: collapse;\r\nfont-family: Arial, sans-serif;\r\nfont-size: 14px;\r\ncolor: #333;\r\n}\r\n\r\n\r\ntable, th, td {\r\nborder: 1px solid black;\r\npadding: 6px;\r\ntext-align: left;\r\n\r\n}\r\n\r\n\r\nth {\r\nbackground-color: #f2f2f2;\r\npadding: 8px;\r\nfont-weight: bold;\r\ncolor: #555;\r\ntext-transform: uppercase;\r\n}\r\n\r\n\r\ntr:nth-child(even) {\r\nbackground-color: #f9f9f9;\r\n}\r\ntr:nth-child(odd) {\r\nbackground-color: #ffffff;\r\n}\r\n\r\n\r\n.systemCost th {\r\nwidth: 50%;\r\n}\r\n\r\n\r\n/* tr:hover {\r\nbackground-color: #c0c5c6;\r\n} */\r\n\r\n\r\ninput {\r\nwidth: 90%;\r\npadding: 4px;\r\nbox-sizing: border-box;\r\nborder: 1px solid #ccc;\r\nborder-radius: 4px;\r\n}\r\ninput:hover {\r\nborder-color: blue; \r\nbox-shadow: 0 0 5px rgba(0, 0, 0, 0.2); \r\n}\r\n\r\ntd input {\r\nmargin: 2px 0;\r\n}\r\n\r\n\r\nth, td {\r\nborder-radius: 4px;\r\n}\r\n\r\n\r\n.excel-file{\r\n  margin-bottom:20px;\r\n}\r\n\r\n\r\n\r\n@keyframes blink {\r\n  50% {\r\n      opacity: 0;\r\n  }\r\n}\r\n\r\n.blink {\r\n  animation: blink 1s step-start infinite;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .project-summary-container {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .left-column.full-width, .right-column.full-width,\r\n  .left-column.half-width, .right-column.half-width {\r\n    flex-basis: 100%; \r\n  }\r\n\r\n  .left-column, .right-column {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
